import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";

const ColumnChartStatistics = ({ siteList = [], queryList = [], chartLoader }) => {
  const [chartOptions, setChartOptions] = useState({
    series: [],
    options: {
      chart: {
        type: "bar",
        height: 350,
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "55%",
          endingShape: "rounded",
        },
      },
      dataLabels: {
        enabled: false,
      },
      xaxis: {
        categories: [],
      },
      colors: [
        "#FF0000", // Dark red
        "#FF3333", // Medium-dark red
        "#FF6666", // Medium red
        "#FF9999", // Light red
        "#FFCCCC", // Very light red
      ],
      legend: {
        position: "bottom",
      },
    },
  });

  useEffect(() => {
    if (siteList.length && queryList.length) {
      setChartOptions((prev) => ({
        ...prev,
        series: [
          {
            name: "Queries",
            data: queryList,
          },
        ],
        options: {
          ...prev.options,
          xaxis: {
            categories: siteList,
          },
        },
      }));
    }
  }, [siteList, queryList]);

  return (
    <div className="p-2">
      <h5 className="fw-bold mb-1 text-center w-100 mt-2">Query Chart</h5>
      {chartLoader ?
        <div
          className="hstack justify-content-center"
          style={{ height: "calc(100vh - 500px)" }}
        >
          <PageLoader/>
        </div>
        :
        chartOptions.series.length > 0 && (
          <ReactApexChart
            options={chartOptions.options}
            series={chartOptions.series}
            type="bar"
            height={302}
          />
        )}
    </div>
  );
};

export default ColumnChartStatistics;